/**
 * Break Management Breadcrumb (Phase 1 UX, Jun 2026)
 * --------------------------------------------------
 * Renders: Dashboard › Break Management › <subpage>   (HR segment removed — NAV-CLEANUP, Sep 2026)
 *
 * Each segment is a Link except the last (current page), which is
 * rendered as plain text in `text-gray-900 font-medium`. Mirrors the
 * existing breadcrumb pattern used on Jurisdiction Directory.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Segment = ({ to, children, current, testid }) => {
  if (current || !to) {
    return (
      <span className="text-gray-900 font-medium" data-testid={testid}>
        {children}
      </span>
    );
  }
  return (
    <Link
      to={to}
      className="text-gray-500 hover:text-gray-900 transition-colors"
      data-testid={testid}
    >
      {children}
    </Link>
  );
};

const Sep = () => (
  <ChevronRight className="w-3.5 h-3.5 text-gray-400 mx-1 shrink-0" />
);

const BreakBreadcrumb = ({ subpage = 'Break Management' }) => {
  return (
    <nav
      className="flex items-center text-xs flex-wrap mb-3"
      aria-label="Breadcrumb"
      data-testid="break-breadcrumb"
    >
      <Segment to="/dashboard" testid="bc-dashboard">
        <span className="inline-flex items-center gap-1">
          <Home className="w-3.5 h-3.5" />
          Dashboard
        </span>
      </Segment>
      <Sep />
      {subpage === 'Break Management' ? (
        <Segment current testid="bc-break-mgmt">
          Break Management
        </Segment>
      ) : (
        <>
          <Segment to="/hr/breaks/history" testid="bc-break-mgmt">
            Break Management
          </Segment>
          <Sep />
          <Segment current testid="bc-subpage">
            {subpage}
          </Segment>
        </>
      )}
    </nav>
  );
};

export default BreakBreadcrumb;
